import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

const initialState: QuestionnaireState = {
  questionnaire: null,
}

export const getQuestionnaire = createAsyncThunk<
  QuestionnaireApiRes,
  {questionnaire_id: number}
>('getQuestionnaire', async (arg, store) => {
  return req(
    '/activity/get_questionnaire',
    // @ts-ignore
    {...arg},
    store,
    false,
    null
  )
})

export const reportSlice = createSlice({
  name: 'questionnaire',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getQuestionnaire.fulfilled, (state, action) => {
      return {
        questionnaire: action.payload.questionnaire || null,
      }
    })
  },
})

export default reportSlice.reducer

/**
 * 问题选项
 * @param key 选项key
 * @param value 选项值
 */
interface QuestionOptions {
  key: string
  value: string
}

/**
 * 问题星选项
 * @param title 选项标题
 * @param star_cnt 星数
 * @param star_id 星id
 */
interface QuestionStarOptions {
  title: string
  starCnt: number
  starId: number
}

/**
 * 问题列表项
 * @param question_id 问题id
 * @param title 问题标题
 * @param required 是否必填 0：否 1：是
 * @param question_type 问题类型 input select
 * @param sub_question_type 子问题类型 single multi
 * @param direction_type 方向类型 across vertical
 * @param option_config 选项配置
 * @param level_config 等级配置
 */
export interface QuestionListItem {
  questionId: number
  title: string
  required: number
  questionType: string
  subQuestionType: string
  directionType: string
  optionConfig: QuestionOptions[]
  levelConfig: QuestionOptions[]
  starConfig: QuestionStarOptions[]
}

/**
 * 问卷配置
 * @param starUrl 星图
 * @param halfStarUrl 半星图
 * @param topBackgroundShadowColor 背景色上
 * @param bottomBackgroundShadowColor 背景色下
 * @param selectUrl 选项
 * @param backgroundUrl 背景图
 * @param buttonContent 按钮文字
 * @param buttonBackgroundShadowColor 按钮背景色
 * @param timeBackgroundUrl 时间背景图
 */
export interface QuestionnaireConfig {
  starUrl: string
  halfStarUrl: string
  topBackgroundShadowColor: string
  bottomBackgroundShadowColor: string
  selectUrl: string
  backgroundUrl: string
  buttonContent: string
  buttonBackgroundShadowColor: string
  timeBackgroundUrl: string
}

/**
 * 问卷数据
 * @param enabled 是否启用 0：否 1：是
 * @param toast 提示信息
 * @param title 标题
 * @param subTitle 副标题
 * @param config 问卷配置
 * @param successMessage 成功提示信息
 * @param questionnaire_id 问卷id
 * @param timestamp 活动时间（拼好的字符串）
 * @param question_list 问题列表
 */
interface QuestionnaireData {
  enabled: number
  toast: string
  title: string
  subTitle: string
  successMessage: string
  config: QuestionnaireConfig
  questionnaireId: number
  timestamp: string
  questionList: QuestionListItem[]
}

interface QuestionnaireApiRes {
  questionnaire: QuestionnaireData | null
}

interface QuestionnaireState {
  questionnaire: null | QuestionnaireData
}
